import { useDateTextFormatting, useTimeTextFormatting } from "src/hooks";

type SessionTimeProps = {
  endDate?: Date;
  startDate: Date;
};

export const SessionTime = ({ endDate, startDate }: SessionTimeProps) => {
  const dateString = useDateTextFormatting(startDate);
  const startTimeString = useTimeTextFormatting(startDate);
  const endTimeString = useTimeTextFormatting(endDate);
  return (
    <time dateTime={`${dateString}`}>
      {dateString} {startTimeString} ~ {endTimeString}
    </time>
  );
};
